import { createSlice } from "@reduxjs/toolkit";

export const commonWhiteListSlice = createSlice({
    name: "commonDataWhiteList",
    initialState: {
        selectedQuality: "480",
        speeds:  [
                { label: '0.25x', value: 0.25 },
                { label: '0.5x', value: 0.5 },
                { label: '0.75x', value: 0.75 },
                { label: 'Normal', value: 1 },
                { label: '1.5x', value: 1.5 },
                { label: '1.75x', value: 1.75 },
                { label: '2x', value: 2 },
            ],
        currentPlaybackRate: 1,
        viewType: "grid",
        volume: 1.0,
        isMuted: false,
    },

    reducers: {
        setSelectedQuality: (state, action) => {
            state.selectedQuality = action.payload;
        },
        setSpeeds: (state, action) => {
            state.speeds = action.payload;
        },
        setCurrentPlaybackRate: (state, action) => {
            state.currentPlaybackRate = action.payload;
        },
        setViewType: (state, action) => {
            state.viewType = action.payload;
        },
        setVolume: (state, action) => {
        state.volume = action.payload;
        },
        setIsMuted: (state, action) => {
        state.isMuted = action.payload;
        },
    },
});

export const { setSelectedQuality, setSpeeds, setCurrentPlaybackRate, setViewType, setVolume, setIsMuted } = commonWhiteListSlice.actions;

export default commonWhiteListSlice.reducer;